// https://vuex.vuejs.org/en/getters.html

export default {
    cartTotalPrice: (state) => {
        let result = state.items.reduce(function (sum, item) {
            return sum + parseFloat(item.price);
        }, 0);
        return result.toFixed(2);
    },
    cartCountTickets: (state) => {
        return state.items.length;
    },
}
